import React from 'react';
import PropTypes from 'prop-types';

export const headShotInfoProps = {
    dataComponent: PropTypes.object,
    headshotSize: PropTypes.number,
    infoItem: PropTypes.shape({
        description: PropTypes.string,
        useDescription: PropTypes.bool
    }),
    player: PropTypes.shape({
        birthDate: PropTypes.string,
        firstName: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        lastName: PropTypes.string.isRequired,
        position: PropTypes.any,
        sweaterNumber: PropTypes.number
    }).isRequired,
    team: PropTypes.shape({
        triCode: PropTypes.string.isRequired
    }).isRequired
};
